/**
 * ThemeToggle Hook
 * Manages dark/light mode switching with localStorage persistence
 * Defaults to system preference if no preference is saved
 */
export const ThemeToggle = {
  mounted() {
    this.button = this.el.querySelector("button");

    this.handleClick = () => {
      const newTheme = this.getCurrentTheme() === "dark" ? "light" : "dark";

      localStorage.setItem("theme", newTheme);
      document.documentElement.classList.toggle("dark");

    };

    this.button?.addEventListener("click", this.handleClick);
  },

  getCurrentTheme() {
    return document.documentElement.classList.contains("dark")
      ? "dark"
      : "light";
  },

  isStickyHeaderVisible() {
    const stickyHeader = document.getElementById("sticky-header");
    return stickyHeader?.classList.contains("is-visible") ?? false;
  },

  destroyed() {
    this.button?.removeEventListener("click", this.handleClick);
  },
};
